
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".978","d":"M11.129 10.688 8.503 8.062m0 0L5.875 10.69m2.628-2.628v6.563M13.84 12.1a3.17 3.17 0 0 0 1.394-1.511 3.14 3.14 0 0 0-.963-3.758 3.2 3.2 0 0 0-1.951-.665h-.802a5.04 5.04 0 0 0-1.05-2.01 5.1 5.1 0 0 0-1.827-1.352 5.12 5.12 0 0 0-4.44.162A5.1 5.1 0 0 0 2.48 4.45a5.04 5.04 0 0 0-.793 4.342c.207.736.58 1.416 1.089 1.989"}})])
          )
        }
      }
    